var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('TabMenu',{attrs:{"id":"tabmenu","model":_vm.items,"activeIndex":_vm.activeIndex}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }